<template>
    <div>
        <div class="product-small" v-if="preview">
            <v-img :src="logo" />
        </div>
        <div class="product-full" v-if="!preview">
            <v-card>
                <v-card-text>
                    <v-tabs color="primary">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab href="#test-client">Test client</v-tab>
                        <v-tab href="#documentation">Documentation</v-tab>
                        <v-tab href="#integration">Integration</v-tab>

                        <v-tab-item value="test-client" class="mt-5">
                            <linked-in-client :id="id" />
                        </v-tab-item>

                        <v-tab-item value="documentation" class="mt-5">
                            <linked-in-docs :id="id" />
                        </v-tab-item>

                        <v-tab-item value="integration" class="mt-5">
                            <linked-in-integration :id="id" />
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";
import LinkedInClient from "./LinkedIn.Client";
import LinkedInDocs from "./LinkedIn.Docs";
import LinkedInIntegration from "./LinkedIn.Integration";
import Logo from "@/assets/linked-in.png";

export default {
    data: () => ({
        logo: Logo
    }),
    components: { LinkedInClient, LinkedInDocs, LinkedInIntegration },
    mixins: [ProductMixin]
}
</script>